"use strict";

/** Установить отображение дней в календаре */
$.widget("fotobook.calendarOrientationWidget", $.fotobook.containereditorbasecontrol, {
    calendar : null,
    options: {
    },

    _create: function() {
        this.calendar = Fotobook.containers.calendar;
        this._super();
    },

    _containerChanged: function(){
        var value = parseInt(this.getContainer().attr("data-orientation"), 10);
        this.element.toggleClass("orientation-vertical", !value).toggleClass("orientation-horizontal", !!value);
        this._super();
    },

    /** Ориентация дней календаря */
    _processClick(){
        return Fotobook.containers.changeContainerAttrs({
            [this.getContainerId()] : {
                "calendar" : {
                    "orientation" : this.element.hasClass("orientation-vertical") ? this.calendar.ORIENTATION_COLUMN : this.calendar.ORIENTATION_ROW,
                },
            }
        });
    },
});
